import React, {useEffect, useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import WizButton from '../../../components/button/WizButton'
import {postEditUserV3} from '../../../apis/user/editUser'
import UnderLineInput from '../../../components/input/UnderLineInput'

interface IProps {
    className?: string
    status: string
    userId: string
    refetch?: any
}

const ChangedStatusMessageModal = ({className, status, userId, refetch}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [userStatus, setUserStatus] = useState('')

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
    }))

    useEffect(() => {
        setUserStatus(status)
    }, [status])

    const onClickSubmit = async () => {
        await postEditUserV3({id: userId, status: userStatus})
        refetch()
        modalRef.current.close()
    }

    return (
        <>
            <WizModal title={'Changed Status Message'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>변경하려하는 상태 메세지를 작성해주세요. </Text>
                <UnderLineInput value={userStatus} className={'mt-[10px]'} onChanged={setUserStatus} />
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton
                        text={'Submit'}
                        type={'blue'}
                        className={'flex-1'}
                        onClick={async () => onClickSubmit()}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(ChangedStatusMessageModal)
